export default "__VITE_ASSET__CybG$EYX__"